module.exports = __webpack_public_path__ + "img/toolbox-icon.3ee0a40b.svg";